module.exports = __webpack_public_path__ + "static/media/blueTag.f214d428.svg";